import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CalendarIcon, MapPin, User } from "lucide-react";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";

export const ConfirmedDates = ({ bookings }) => {
  // Filter only confirmed and paid bookings, sorted by date
  const confirmedBookings = bookings
    .filter(booking => booking.payment_status === 'confirmed' || booking.payment_status === 'paid')
    .sort((a, b) => new Date(a.event_date) - new Date(b.event_date));

  return (
    <Card className="border-2 shadow-xl">
      <CardHeader className="bg-gradient-to-r from-green-50 to-emerald-50 border-b">
        <CardTitle className="text-2xl flex items-center justify-between">
          <span>Dates Confirmées</span>
          <span className="px-4 py-2 rounded-full text-lg font-bold bg-green-500 text-white">
            {confirmedBookings.length}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        {confirmedBookings.length === 0 ? (
          <div className="text-center py-12">
            <CalendarIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Aucune réservation confirmée pour le moment</p>
          </div>
        ) : (
          <div className="space-y-3 max-h-[600px] overflow-y-auto">
            {confirmedBookings.map((booking) => (
              <div
                key={booking.id}
                className="p-5 border-2 border-green-200 bg-green-50 rounded-xl hover:border-green-400 transition-all"
              >
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 flex items-center gap-2">
                      <CalendarIcon className="h-5 w-5 text-green-600" />
                      {format(parseISO(booking.event_date), "EEEE dd MMMM yyyy", { locale: fr })}
                    </h3>
                    <p className="text-sm text-gray-600 ml-7">{booking.package_name}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      booking.payment_status === 'paid' 
                        ? 'bg-blue-500 text-white' 
                        : 'bg-green-500 text-white'
                    }`}>
                      {booking.payment_status === 'paid' ? 'Payé' : 'Confirmé'}
                    </span>
                    <span className="text-lg font-bold text-green-600">
                      {booking.total_price}€
                    </span>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-3 text-sm text-gray-700 ml-7">
                  <div className="flex items-center gap-2">
                    <User className="h-4 w-4 text-green-600" />
                    <div>
                      <p className="font-semibold">{booking.customer_name}</p>
                      <p className="text-xs text-gray-600">{booking.customer_email}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4 text-green-600" />
                    <div>
                      <p className="font-semibold">Lieu</p>
                      <p className="text-xs text-gray-600">{booking.event_location}</p>
                    </div>
                  </div>
                </div>

                {booking.event_type && (
                  <div className="mt-3 ml-7">
                    <span className="px-3 py-1 bg-white border border-green-300 rounded-full text-xs font-medium text-green-700">
                      {booking.event_type}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
